import React from 'react';
import { Landmark, User } from 'lucide-react';
import { WorkspaceChooser } from '../../components/demoShell/WorkspaceChooser';
import { governmentDemoNotice, governmentDemoUrl } from '../../data/demoCenter';
export function GovernmentDemoPage() {
  return <WorkspaceChooser domainId="government" eyebrow="NATIONAL CAPABILITY AND DEVELOPMENT SYSTEM" title="Government & Public Institutions" description="Connect citizen development and practical support with program delivery, geographic oversight and accountable institutional decisions." cards={[{
    id: 'citizen',
    title: 'Citizen Workspace',
    body: 'Personal development, services, requests and review.',
    buttonLabel: 'Open the Government demo',
    icon: User,
    href: governmentDemoUrl
  }, {
    id: 'administration',
    title: 'Administration Control Panel',
    body: 'Citizen records, delivery workflows and geographic oversight.',
    buttonLabel: 'Open the Government demo',
    icon: Landmark,
    href: governmentDemoUrl
  }]} footnote={<p className="rounded-lg border border-lavender/25 bg-lavender-pale px-4 py-3 text-sm leading-relaxed text-ink-dark" data-id="element-2892" data-mp="ysquuo7j3x1v">
          The Government demonstration runs as its own workspace and opens at its workspace chooser in a new tab, where you pick the Citizen
          Workspace or the Administration Control Panel. It explores the fictional Republic of Nordland: a citizen’s development and support
          journey, referrals, identity reviews and appeals, and reporting from national level down to districts. {governmentDemoNotice}.
        </p>} data-id="element-2891" data-mp="20avzwallzqdl" />;
}